import type { FC, ReactNode } from 'react';
import { TableCell } from '@mui/material';

import { styles } from './TableCell.styles';

interface TicketTableCell {
  sxOverride?: Record<string, string | number>;
  children?: ReactNode;
}

const TicketTableCell: FC<TicketTableCell> = ({ children, sxOverride }) => (
  <TableCell
    sx={(theme) => ({
      ...styles.tableCell(theme),
      ...sxOverride,
    })}
  >
    {children}
  </TableCell>
);

export default TicketTableCell;
